import jMoment from "components/classes/Jmomen";
// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const INDEX_FEED_RESERVE_SUCCESS = "INDEX_FEED_RESERVE_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexReserveSuccess(payload) {
  return {
    type: INDEX_FEED_RESERVE_SUCCESS,
    payload: payload, // payload OR {data: tables}
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Reserve@index")) {
      let path = `/feeding/reserve`;
      api
        .get(path, { params })
        .then((res) => {
          dispatch(_indexReserveSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            ".خطا در دریافت اطلاعات! لطفا مجدد تلاش کنید",
            app.translate("routes.home.feed.reserve.Indexing Rules Failed")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @param {Object} [data={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function indexReservePrint(data = {}, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("ReportFeeding@print_reserve")) {
      let path = `/feeding/report/print_reserve`;
      api
        .post(path, { data, params })
        .then((res) => {
          dispatch(_indexReserveSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          app.error(
            err,
            "routes.home.feed.rules",
            "خطا در ارسال اطلاعات",
            app.translate("routes.home.feed.reserve.Indexing Rules Failed")
          );
          callback(err);
        });
    }
  };
}

/**
 *
 * @return {{type: String, payload: Object}}
 */
export function emptyReserve() {
  return _indexReserveSuccess({ data: {} });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    reserves: [],
  },
  action
) {
  switch (action.type) {
    case INDEX_FEED_RESERVE_SUCCESS:
      return Object.assign({}, state, {
        reserves: action.payload.data.reserves,
      });
    default:
      return state;
  }
}
